<template>
<div class="create-application container">
  <router-link  :to="`/applications${queryParams}`" class="create-application__breadcrumbs">
    <img src="@/assets/images/icons/back-arrow.svg" alt="arrow">
    <p>Заявки</p>
  </router-link>

  <div class="create-application__header">
    <div>
      <h1 class="create-application__title main-title">Создание заявки</h1>
      <div v-if="route.path.includes('edit')" class="create-application__author">Автор: Взис 106</div>
    </div>
  </div>

  <Basic  v-model="form" :salaryFromError="salaryFromError" :documents_for_sign_in="documents_for_sign_in"
                    :workingConditions="fieldsVacancies" class="create-application__block"/>

  <div class="flex gap-8 w-full">
    <VButtonNew style="width: 352px;" style-type="grey" label="Отменить" @click="goBack"/>
    <VButtonNew style="width: 448px;" :label="isEdit ? 'Сохранить' : 'Создать заявку'" @click="apply"/>
  </div>
</div>
</template>
<script setup>
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import Basic from "@/components/Application/Basic.vue";
import VButtonNew from "@/components/UI/VButtonNew/index.vue";
import applications from "@/api/applications";
import useOffsetTop from "@/hooks/getOffsetTopScroll";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
const router = useRouter();
const route = useRoute();

const form = ref( {
  title: "",
  speciality_id: null,
  specialityName: "",
  place_of_work: "",
  experience: "",
  division_id: null,
  legal_entity_id: null,
  is_fix_salary: false,
  fix_salary: null,
  salary_from: null,
  salary_to: null,
  hiring_plan_count: null,
  date_start_work: "",
  reason: "",
  priority: "",
  documents: [],
  description: ""
})
const salaryFromError = ref(false)
const fieldsVacancies = ref({
  priority:  {'Низкий': 'Низкий', 'Средний': 'Средний', 'Высокий': 'Высокий'},
   subdivision: { "Подразделение разработки": "Подразделение разработки", "Административный блок": "Административный блок",
     "Маркетинг": "Маркетинг", "Бухгалтерия": "Бухгалтерия", "Консалтинг": "Консалтинг", "HR": "HR" },
  work_experience: { "Без опыта": "Без опыта", "От 1 года до 3 лет": "От 1 года до 3 лет", "От 3 лет до 6 лет": "От 3 лет до 6 лет", "От 6 лет": "От 6 лет" },
  legalEntity: { 'ООО "PROTECTOR"': 'ООО "PROTECTOR"', "ООО Маркетинг": "ООО Маркетинг" , "ООО Консалтинг": "ООО Консалтинг" } });


const isEdit = computed(() => {
  return route.fullPath?.includes("edit")
})

const goBack = () => {
  router.back();
};

const fixSalaryRequired = (val) => {
  if (!form.value.is_fix_salary) {
    return true
  } else {
    return !!val
  }
}

const rangeSalaryRequiredTo = (val) => {
  if (!!form.value.is_fix_salary) {
    return true
  } else {
    if(!!form.value.salary_from) {
      return true
    } else {
      return !!val
    }
  }
}

const rangeSalaryRequiredFrom = (val) => {
  if (!!form.value.is_fix_salary) {
    return true
  } else {
    if(!!form.value.salary_to) {
      return true
    } else {
      return !!val
    }
  }
}

const rules = computed(() => ({
  title: {required},
  speciality_id: {required},
  // speciality: {required},
  hiring_plan_count: {required},
  // region: {required},
  place_of_work: {required},
  experience: {required},
  description: {required},
  // educationLevel: {required},
  // workExperience: {required},
  division_id: {required},
  legal_entity_id: {required},
  // schedule: {required},
  // travelingExpenses: {required},
  salary_to: {rangeSalaryRequiredTo},
  salary_from: {rangeSalaryRequiredFrom},
  fix_salary: {fixSalaryRequired},
  priority: {required},
  // agreementConditions: {required},
  // contractTerm: {requiredFieldContractTerm},
}));
const v$ = useVuelidate(rules, form);

const queryParams = computed(() => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(route.query)) {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  }
  return '?' + searchParams.toString()
})

const apply = async () => {
  const validate = await v$.value.$validate();

  if (!validate) {
    useOffsetTop();
    return;
  }

  const args = {
//Описание вакансии
    title: form.value.title,
    speciality_id: form.value.speciality_id,
    place_of_work: form.value.place_of_work,
    experience: form.value.experience,
    division_id: form.value.division_id,
    legal_entity_id: form.value.legal_entity_id,
//Зарплата
    is_fix_salary: form.value.is_fix_salary,
    fix_salary: form.value.fix_salary ? form.value.fix_salary : null,
    salary_from: form.value.salary_from ? form.value.salary_from : 0,
    salary_to: form.value.salary_to ?  form.value.salary_to : null,
//План по подборк
    hiring_plan_count: form.value.hiring_plan_count,
    date_start_work: form.value.date_start_work,
    reason: form.value.reason,
    priority: form.value.priority,
    documents: form.value.documents,
//Описание
    description: form.value.description
  }

  try {
    if(isEdit.value) {
      await applications.updateApplications(route.params.id ,args)
    } else {
      await applications.createApplications(args)
    }
    await router.push('/applications?tabs=active')
  } catch (e) {
    console.log(e)
  }
}
const documents_for_sign_in = ref([])
onMounted(async () => {
  if(isEdit.value) {
    const res = await applications.getApplicationId(route.params.id);
    form.value.title = res.data.title
    form.value.speciality_id = res.data.speciality_id
    form.value.specialityName = res.data.speciality_name
    form.value.place_of_work = res.data.place_of_work
    form.value.experience = res.data.experience
    form.value.division_id = res.data.division_id
    form.value.legal_entity_id = res.data.legal_entity_id
    form.value.is_fix_salary = res.data.is_fix_salary
    if(form.value.is_fix_salary) {
      form.value.fix_salary = res.data.fix_salary
    }else {
      form.value.salary_from = res.data.salary_from
      form.value.salary_to = res.data.salary_to
    }
    form.value.hiring_plan_count = res.data.hiring.plan
    form.value.date_start_work = res.data.date_start_work
    form.value.reason = res.data.reason
    form.value.priority = res.data.priority
    res.data.documents?.forEach(el => {
      form.value.documents.push(el.id)
    })

    documents_for_sign_in.value = res.data.documents
    form.value.description = res.data.description
  }
})

</script>
<style lang="scss" scoped>
.create-application {
  margin-bottom: 32px;
  &__title {
    margin-top: 12px;
  }

  &__wrapper {
    padding-top: 12px;
  }

  &__breadcrumbs {
    display: flex;
    margin-top: 17.5px;
    align-items: center;
    color: $gray;
    text-decoration: none;
    cursor: pointer;
    user-select: none;

    p {
      margin-left: 4px;
      font-size: 14px;
      font-weight: 400;
    }

    img {
      width: 20px;
    }
  }

  &__author {
    font-size: 14px;
    font-weight: 500;
    color: $dark-blue;
    margin-top: 8px;
  }

  &__header {
    margin-bottom: 24px;
  }

  &__block {
    margin-bottom: 24px;
  }
}
</style>